import { fetchWrapper } from '../Helpers';

const baseUrlcsv = `${process.env.REACT_APP_API_URL}` + "/influencer-lists";

export const influencerlistcsvexportService = {
    previewcsv,
    exportcsv
};
function previewcsv(id) {


    return fetchWrapper.get(`${baseUrlcsv}/${id}/export/preview`);

}

function exportcsv(id) {
    return fetchWrapper.getfileFordownload(`${baseUrlcsv}/${id}/export`);

}



